import script from "./SideMenuCrossOperatorsGroupChatInfoTab.vue?vue&type=script&lang=ts&setup=true"
export * from "./SideMenuCrossOperatorsGroupChatInfoTab.vue?vue&type=script&lang=ts&setup=true"

import "./SideMenuCrossOperatorsGroupChatInfoTab.vue?vue&type=style&index=0&id=7c581341&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c581341"]])

export default __exports__